module.exports = __webpack_public_path__ + "img/app.50bca7b4.png";